import { useAuth0 } from "@auth0/auth0-react";
import { HintField, InputField, LabelField, MyRadioGroup } from "components";
import { AsyncAutoCompleteField } from "components/autoCompleteField/AsyncAutoFieldOld";
import { useFormik } from "formik";
import { useSearch } from "hook";
import AuthService from "Lib/API/Auth";
import FinanceService from "Lib/API/Finance";
import MemberService from "Lib/API/Member";
import Service from "Lib/service";
import { AddNewUserSchema } from "pages/ValidationSchema";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useParams } from "react-router-dom";

const AddNewUser = ({
  account_id,
  refresh,
  setRefresh,
  setUserFamily,
  setFamilyMember,
  familyMember,
  userFamily,
  setOpen,
}) => {
  const [search, setSearch] = useState(undefined);
  const { getAccessTokenSilently } = useAuth0();
  const { searchAction } = useSearch({ action: setSearch });
  const [loading, setLoading] = useState(false);
  const [subLoading, setSubLoading] = useState(false);
  const [contactsList, setContactsList] = React.useState([]);
  const { id } = useParams();
  const [page, setPage] = React.useState(1);
  const [total, setTotal] = React.useState();
  const [list, setList] = React.useState([]);

  // async function fetchMyAPI1() {
  //   setLoading(true);
  //   const token = await getAccessTokenSilently();
  //   await MemberService.getContacts(token, search).then((res) => {
  //     if (res?.contacts) {
  //       res.contacts.map((item) => {
  //         item.id = item.member_id;
  //         item.label = item?.first_name + " " + item?.last_name;
  //         item.value = item._id;
  //         return item;
  //       });
  //       setContactsList(res?.contacts);
  //     }
  //     setLoading(false);
  //   });
  // }
  async function fetchMyAPI1() {
    enableLoading(true);
    const token = await getAccessTokenSilently();
    await FinanceService.getACcountNames(token, search)
      .then((res) => {
        if (res?.accounts) {
          res.accounts.map((item) => {
            item.label = item.family_name;
            item.value = item._id;
            return item;
          });
          setContactsList(res?.accounts);
        }
        enableLoading(false);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  }
  const getAccount = async (token) => {
    try {
      return await Service.get(
        `/accounts/contact?page=${page}&size=${6}&member=all&account=${id}`,
        token
      );
    } catch (error) {
      throw error;
    }
  };

  const calculateProfileCompletion = (user) => {
    const {
      account,
      createdAt,
      id,
      member_id,
      profile_img,
      relationship,
      _id,
      backGround,
      account_id,
      organization,
      updatedAt,
      __v,
      ...data
    } = { ...(user ? user : {}) };
    const insertedValues = Object.values(data);
    const insertedValuesLng = insertedValues.filter((it) => {
      if (it !== "") {
        if (typeof it === "object") {
          if (it?.formattedAddress !== undefined) {
            return true;
          } else return false;
        }
        return true;
      } else return false;
    })?.length;
    return Math.round((insertedValuesLng / 23) * 100) > 100
      ? 100
      : Math.round((insertedValuesLng / 23) * 100);
  };

  const colors = ["#4CAF50", "#2A99FA"];

  const enableLoading = (value) => {
    setLoading(value);
  };

  async function fetchMyAPI() {
    enableLoading(true);
    const token = await getAccessTokenSilently();
    getAccount(token)
      .then((res) => {
        if (res) {
          const result = res?.contacts.map((item) => {
            item.id = item._id;
            const random = Math.floor(Math.random() * 2);
            if (!item.profile_img) {
              item.backGround = colors[random];
            }
            item.profile_completion = calculateProfileCompletion(item);
            return item;
          });
          if (page === 1) setTotal(res.total);
          setList(result);
        }
        enableLoading(false);
      })
      .catch((err) => {
        enableLoading(false);
        // toastr.error("Error", err?.data?.message);
      });
  }

  useEffect(() => {
    if (!account_id) fetchMyAPI1();
  }, [search]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: "",
      last_name: "",
      account: account_id ? account_id : "",
      permission: "member",
    },
    validationSchema: AddNewUserSchema,
    onSubmit: async (values) => {
      setSubLoading(true);
      const token = await getAccessTokenSilently();
      const input = {
        first_name: values.first_name,
        last_name: values.last_name,
        account_id: account_id ? values.account : values.account._id,
        account_permission:
          values.permission === "member" ? "family_member" : "admin",
      };
      await AuthService.postAddFamilyNewMember(input, token)
        .then((res) => {
          fetchMyAPI();
          setSubLoading(false);
          setOpen(false);
          setRefresh(!refresh);
          toastr.success("User created successfully.");
        })
        .catch((err) => {
          setSubLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    },
  });

  useEffect(() => {
    if (familyMember === true) {
      setUserFamily(true);
    }
  }, []);

  return (
    <div className="add-new-user">
      <div className="px-40 pt-10">
        <p className="new-user-header mb-5">Create New User</p>
        <InputField
          mandatory={true}
          {...{
            formik,
            title: "First Name",
            name: "first_name",
            placeholder: "First name",
            checkValidation: true,
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
            if (e.key === ' ' && formik.values?.first_name === '') {
              e.preventDefault();
            }
          }}
        />
        <InputField
          mandatory={true}
          {...{
            formik,
            title: "Last Name",
            name: "last_name",
            placeholder: "Last name",
            checkValidation: true,
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
            if (e.key === ' ' && formik.values?.last_name === '') {
              e.preventDefault();
            }
          }}
        />
        {!account_id && (
          <div className="sm-12">
            <LabelField title="Account" mandatory={true} />
            <AsyncAutoCompleteField
              mandatory={true}
              {...{
                formik,
                name: "account",
              }}
              error={formik?.errors["account"]}
              touched={formik?.touched["account"]}
              onInputChange={(text) => searchAction(text)}
              classNamePrefix="react-select"
              options={contactsList}
              active={false}
              isLoading={loading}
              handleChange={(e) => formik.setFieldValue("account", e)}
              value={formik.values.account}
            />
          </div>
        )}
        <div className="py-5">
          <LabelField title="Account permission" />
          <MyRadioGroup
            row
            handleChange={(val) =>
              formik.setFieldValue &&
              formik.setFieldValue("permission", val.target.value)
            }
            value={formik.values.permission}
            name="permission"
            className="my-5"
            formsControls={[
              { value: "member", label: "Member" },
              { value: "admin", label: "Admin" },
            ]}
          />
        </div>
        <div
          className="form-group"
          style={{ textAlign: "center", marginBottom: "0px" }}
        >
          <button
            disabled={!formik.isValid}
            type="submit"
            className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
            onClick={() => formik.handleSubmit()}
          >
            <span style={{ fontSize: 13, fontWeight: "600" }}>
              Create New User
            </span>
            {subLoading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </div>
      </div>
    </div>
  );
};
export default AddNewUser;
